import React from 'react';

import AnalyticsClient from '../clients/AnalyticsClient';

export const noop = () => Promise.resolve();

export default React.createContext<AnalyticsClient>({
  fireEvent: () => null,
  getAnalyticsWebClient: () => {
    throw new Error('Must not use default provider');
  },
  markContentLoad: noop,
  page: noop,
  startUIViewedEvent: noop,
  track: noop,
  trackOperational: noop,
  ui: noop,
  getDefaultSource: () => 'home',
});
